<template>
  <div class="tm-history">

    <!--поиск + фильтрация + описание-->
    <div class="uk-grid" data-uk-grid>

      <!--поиск + фильтрация-->
      <div :class="currentTab != 'ordersEducation' ? 'uk-width-1-3@l uk-width-1-2': 'uk-width-1-2'">
        <!--поиск и выбор кол-ва заказов на страницу-->
        <div class="uk-margin">
          <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
            <!--поиск по полю номера заказа-->
            <div class="uk-width-expand">
              <div class="uk-inline uk-width-1-1">
                <button type="button" class="uk-form-icon uk-form-icon-flip uk-icon" @click="clearSearchField">
                  <md-icon>clear</md-icon>
                </button>
                <input
                    class="uk-input"
                    :placeholder="local_page_keys.placeholder_for_search_order_number"
                    v-model="searchByOrderNumber"
                    @input="checkmethod" />
              </div>
            </div>
            <!--кол-во заказов в списке-->
            <div>
              <select class="uk-select"
                      v-model="pagination.perPage"
                      name="perPage"
                      ref="perPage"
                      id="perPage"
                      v-on:change="changeListLength">
                <template v-for="item in pagination.perPageOptions">
                  <option :label="item"
                          :value="item"
                          :key="item">
                    {{ item }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>

        <!--сортировка для всех табов, кроме ВСЕ ЗАКАЗА -->
        <div class="uk-margin" v-if="tab !== 0  && tab !== 9  && currentTab != 'ordersEducation'">
          <div class="uk-width-expand uk-position-relative uk-position-z-index">
            <div class="uk-grid uk-grid-small uk-grid-collapse_ uk-flex-middle uk-child-width-1-1 1" data-uk-grid>
              <div>
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <!--выбор даты-->
                  <div class="uk-width-expand">
                    <div style="line-height: 1.2">
                      {{ local_page_keys.title_get_selected_period }}
                    </div>
                    <div class="uk-margin-small-top">
                      <DatepickerDialog
                          :dateTimePeriod=dateTimePeriod
                          :choosenPeriod.sync=choosenPeriod
                          :getPeriod=getPeriod
                          :todayDate=todayDate></DatepickerDialog>
                    </div>
                  </div>
                  <!--кнопка ПОКАЗАТЬ-->
                  <div v-if="dateTimePeriod !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
                      <!--                    {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                  <div v-if="sorted_mode !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table" @click="$emit('cancel_all_sort', currentTab)" data-uk-tooltip="Сбросить фильтрацию">
                      <md-icon>clear</md-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if=" currentTab === 'ordersEducation'">
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <div v-if="Object.keys(users_for_history).length > 0" :mdClearable="true">
                    <v-select id="usersSelect"
                              :options="formattedUserForHistory"
                              label="text"
                              name="usersSelect"
                              ref="usersSelect"
                              multiple
                              v-model="chosenUsers"
                              :reduce="_function => _function.value"
                              :clearable="true"
                              class="tm-v-select"
                              placeholder="--">
                      <template #search="{attributes, events}">
                        <input
                            class="vs__search"
                            v-bind="attributes"
                            v-on="events"/>
                      </template>
                    </v-select>
                  </div>
                  <div class="uk-width-auto" v-if="showShowWorkerButton">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
                      <!--                            {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="currentTab !== 'regularCustomers'">
                <select class="uk-select"
                        v-model="selectSortOptionEducation"
                        name="selectSortOptionEducation"
                        ref="selectSortOptionEducation"
                        id="selectSortOptionEducation"
                        placeholder="--"
                        v-on:change="selectSortOptionEducationAction">
                  <option v-for="option of options_for_select_sort_for_orders_education_tab"
                          :value="option.value"
                          :key="option.id">
                    {{ local_page_keys[option.text] }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!--сортировка для ordersEducation -->
        <div class="uk-margin" v-if="currentTab === 'ordersEducation'">
          <div class="uk-width-expand uk-position-relative uk-position-z-index">
            <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
              <!--даты-->
              <div>
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <!--выбор даты-->
                  <div class="uk-width-expand">
                    <div style="line-height: 1.2">
                      {{ local_page_keys.title_get_selected_period }}
                    </div>
                    <div class="uk-margin-small-top">
                      <DatepickerDialog
                          :dateTimePeriod=dateTimePeriod
                          :choosenPeriod.sync=choosenPeriod
                          :getPeriod=getPeriod
                          :todayDate=todayDate></DatepickerDialog>
                    </div>
                  </div>
                  <!--кнопка ПОКАЗАТЬ-->
                  <div v-if="dateTimePeriod !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
                      <!--                    {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                  <div v-if="sorted_mode !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table" @click="$emit('cancel_all_sort', currentTab)" data-uk-tooltip="Сбросить фильтрацию">
                      <md-icon>clear</md-icon>
                    </button>
                  </div>
                </div>
              </div>
              <!--работник-->
              <div>
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <!--список-->
                  <div class="uk-width-expand" v-if="Object.keys(users_for_history).length > 0" :mdClearable="true">
                    <div style="line-height: 1.2">
                      Выбор работника
                    </div>
                    <div class="uk-margin-small-top">
                      <v-select id="usersSelect"
                                :options="formattedUserForHistory"
                                label="text"
                                name="usersSelect"
                                ref="usersSelect"
                                multiple
                                v-model="chosenUsers"
                                :reduce="_function => _function.value"
                                :clearable="true"
                                class="tm-v-select"
                                placeholder="Выберите ретушера">
                        <template #search="{attributes, events}">
                          <input
                              class="vs__search"
                              v-bind="attributes"
                              v-on="events"/>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <!--кнопка-->
                  <div class="uk-width-auto" v-if="showShowWorkerButton">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
<!--                      {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                </div>
              </div>
              <!--фильтр по статусу-->
              <div>
                <div style="line-height: 1.2">
                  Выбор статуса
                </div>
                <div class="uk-margin-small-top">
                  <select class="uk-select"
                          v-model="selectSortOptionEducation"
                          name="selectSortOptionEducation"
                          ref="selectSortOptionEducation"
                          id="selectSortOptionEducation"
                          placeholder="--"
                          v-on:change="selectSortOptionEducationAction">
                    <option v-for="option of options_for_select_sort_for_orders_education_tab"
                            :value="option.value"
                            :key="option.id">
                      {{ local_page_keys[option.text] }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--сортировка для таба ВСЕ ЗАКАЗА -->
        <div class="uk-margin" v-if="tab === 0 && currentTab != 'ordersEducation'">
          <div class="uk-grid uk-grid-small uk-flex-bottom" data-uk-grid>
            <!--сортировка-->
            <div class="uk-width-expand">
              <div class="uk-grid uk-grid-small" data-uk-grid>
                <!--Сортировать историю заказов по-->
                <div class="uk-width-1-1">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                    <div style="line-height: 1.3">
                      {{ local_page_keys.title_table_select_option_for_sort }}
                    </div>
                    <div class="uk-margin-small-top">
                      <select class="uk-select"
                              v-model="selectSortOption"
                              name="selectSortOption"
                              ref="selectSortOption"
                              id="selectSortOption"
                              placeholder="--"
                              v-on:change="clearSelectedOptions">
                        <option value="" disabled selected hidden>--</option>
                        <option v-for="option of options_for_select_sort_for_orders_tab"
                                :value="option.value"
                                :key="option.id">
                          {{ local_page_keys[option.text] }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!--если "Периоду создания/обновления заказа"-->
                <div class="uk-width-1-1 uk-position-relative uk-position-z-index" v-if="selectSortOption === 'create_update_period'">
                  <div>
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                      <div>
                        <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-1-1" data-uk-grid>
                          <!--списки-->
                          <div class="uk-width-expand">
                            <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                              <!--datepicker-dialog-->
                              <div class="uk-animation-fade uk-animation-fast">
                                <div style="line-height: 1.2">{{ local_page_keys.title_get_selected_period }}</div>
                                <div class="uk-margin-small-top">
                                  <DatepickerDialog
                                      :dateTimePeriod = dateTimePeriod
                                      :choosenPeriod.sync=choosenPeriod
                                      :getPeriod = getPeriod
                                      :todayDate = todayDate></DatepickerDialog>
                                </div>
                              </div>
                              <!--list-->
                              <div v-if="choosenPeriod.length > 1">
                                <div style="line-height: 1.2">{{ local_page_keys.lable_get_selected_period_with_field }}</div>
                                <div class="uk-margin-small-top">
                                  <select class="uk-select"
                                          v-model="selectedDateField"
                                          name="selectedDateField"
                                          ref="selectedDateField"
                                          id="selectedDateField">
                                    <option value="" disabled selected hidden>--</option>
                                    <option :value="'created_at'">{{ local_page_keys.table_header_created_at }}</option>
                                    <option :value="'updated_at'">{{ local_page_keys.table_header_updated_at }}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--кнопка ПОКАЗАТЬ-->
                          <div class="uk-width-auto" v-if="selectedDateField !== ''">
                            <button class="uk-button uk-button-success tm-button-schedule-table" @click="getOrdersHistoryByPeriod" style="color: #fff !important;">
<!--                              {{ local_page_keys.lable_button_show_order_period }}-->
                              <md-icon>arrow_forward_ios</md-icon>
                              <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--если "Работе ретушеров/про-ретушеров"-->
                <div class="uk-width-1-1 uk-position-relative uk-position-z-index" v-if="selectSortOption === 'worker'">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                    <div>
                      <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-1-1" data-uk-grid>
                        <!--списки-->
                        <div class="uk-width-expand">
                          <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                            <!--datepicker-dialog-->
                            <div>
                              <div style="line-height: 1.3">
                                {{ local_page_keys.title_sort_by_worker }}
                              </div>
                              <div class="uk-margin-small-top">
                                <DatepickerDialog
                                    :dateTimePeriod = dateTimePeriod
                                    :choosenPeriod.sync=choosenPeriod
                                    :getPeriod = getPeriod
                                    :todayDate = todayDate></DatepickerDialog>
                              </div>
                            </div>
                            <!--list-->
                            <div v-if="choosenPeriod.length > 1">
                              <div style="line-height: 1.3">
                                {{ local_page_keys.lable_role_select }}
                              </div>
                              <div class="uk-margin-small-top">
                                <select class="uk-select"
                                        v-model="choosenRole"
                                        name="choosenRole"
                                        ref="choosenRole"
                                        id="choosenRoleNew"
                                        v-on:change="showUserSelect">
                                  <option value="" disabled selected hidden>--</option>
                                  <option v-for="option in roles"
                                          :key="option.value"
                                          :value="option.value"
                                          v-text="option.text">
                                  </option>
                                </select>
                              </div>
                            </div>
                            <!--list-->
                            <div v-if="Object.keys(users_for_history).length > 0" :mdClearable="true">
                              <v-select id="usersSelect"
                                        :options="formattedUserForHistory"
                                        label="text"
                                        name="usersSelect"
                                        ref="usersSelect"
                                        multiple
                                        v-model="chosenUsers"
                                        :reduce="_function => _function.value"
                                        :clearable="true"
                                        class="tm-v-select"
                                        placeholder="--">
                                <template #search="{attributes, events}">
                                  <input
                                      class="vs__search"
                                      v-bind="attributes"
                                      v-on="events"/>
                                </template>
                              </v-select>
                            </div>
                          </div>
                        </div>
                        <!--кнопка ПОКАЗАТЬ-->
                        <div class="uk-width-auto" v-if="showShowWorkerButton">
                          <button class="uk-button uk-button-success tm-button-schedule-table"
                                  @click="getWorkerPeriodInfo"
                                  style="color: #fff !important;">
<!--                            {{ local_page_keys.lable_button_show_order_period }}-->
                            <md-icon>arrow_forward_ios</md-icon>
                            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--если "Статусу заказа"-->
                <div class="uk-width-1-1 uk-position-relative uk-position-z-index" v-if="selectSortOption === 'status'">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                    <div>
                      <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-1-1" data-uk-grid>
                        <!--списки-->
                        <div class="uk-width-expand">
                          <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                            <!--datepicker-dialog-->
                            <div>
                              <div style="line-height: 1.3">
                                {{ local_page_keys.title_sort_by_worker }}
                              </div>
                              <div class="uk-margin-small-top">
                                <DatepickerDialog
                                    :dateTimePeriod = dateTimePeriod
                                    :choosenPeriod.sync=choosenPeriod
                                    :getPeriod = getPeriod
                                    :todayDate = todayDate></DatepickerDialog>
                              </div>
                            </div>
                            <!--list-->
                            <div v-if="choosenPeriod.length > 1">
                              <div style="line-height: 1.3">
                                {{ local_page_keys.title_sort_by_worker }}
                              </div>
                              <div class="uk-margin-small-top">
                                <v-select id="choosenStatus"
                                          :options="formattedStatuses"
                                          label="text"
                                          name="choosenStatus"
                                          ref="choosenStatus"
                                          multiple
                                          v-model="choosenStatus"
                                          :reduce="_function => _function.value"
                                          :clearable="true"
                                          class="tm-v-select"
                                          placeholder="--">
                                  <template #search="{attributes, events}">
                                    <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"/>
                                  </template>
                                </v-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--кнопка ПОКАЗАТЬ-->
                        <div class="uk-width-auto" v-if="showStatusButton">
                          <button class="uk-button uk-button-success tm-button-schedule-table"
                                  @click="getSortByStatus"
                                  style="color: #fff !important;">
<!--                            {{ local_page_keys.lable_button_show_order_period }}-->
                            <md-icon>arrow_forward_ios</md-icon>
                            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--сброс сортировки-->
            <div class="uk-width-auto" v-if="sorted_mode !== ''">
              <button class="uk-button uk-button-success tm-button-schedule-table"
                      @click="$emit('cancel_all_sort', true)"
                      data-uk-tooltip="Сбросить фильтрацию">
                <md-icon>clear</md-icon>
              </button>
            </div>
          </div>
        </div>
        <label v-if="currentTab !== 'ordersUnviewed'">
          <input type="checkbox"
                   :checked="searchInArchive[currentTab]"
                   @input="archiveChecker"
                   class="uk-checkbox">
                  Поиск по архиву
          </label>
      </div>

      <!--описание-->
      <div v-if="tab !== 0 && tab !== 6 && currentTab !== 'regularCustomers' && currentTab !== 'ordersUnviewed'" class="uk-width-expand">
        <div class="uk-padding-small uk-background-muted">
          <div class="uk-grid uk-grid-small uk-child-width-expand" data-uk-grid>
            <div class="uk-width-auto">
              <md-icon style="color: rgb(76, 175, 80)">info</md-icon>
            </div>
<!--            <div v-if="currentTab === 'ordersAll'">-->
<!--              1 таб ordersAll-->
<!--            </div>-->
            <!--ordersDone-->
            <div v-if="tab === 1">
              <div class="uk-text-bold">Готовы</div>
              <div class="uk-margin-top">Координатор: Необходима ежедневная проверка выполненых заказов за предыдуший день (несколько дней) для анализа самых медленных в выполении заказов.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Добавление сортировки по столбцу “От активности клиента“</li>
                <li>3. Рассматриваем и анализируем причину, почему так долго были заказы в работе</li>
                <li>4. Находим тех баги и отправляем их в тех отдел, орг проблемы рассматриваем с проверяющими-ретушерами индивидуально</li>
              </ul>
            </div>
            <!--ordersInWork-->
            <div v-else-if="tab === 2">
              <div class="uk-text-bold">В работе</div>
              <div class="uk-margin-top">Координатор:  Необходима проверка самых долговыполняемых заказов 1 раз в 2 часа для отлова ошибок.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Добавление сортировки по столбцу “От активности клиента“</li>
                <li>2. Рассматриваем и анализируем причину, почему так долго были заказы в работе</li>
                <li>3. Находим тех баги и отправляем их в тех отдел, орг проблемы рассматриваем с проверяющими-ретушерами индивидуально</li>
              </ul>
            </div>
            <!--rejectByAdmin-->
            <div v-else-if="tab === 3">
              <div class="uk-text-bold">Отклонено проверяющим</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет понимания причины отказов проверяющих.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Прорабатывайте причины отказа от заказа у проверяющих</li>
                <li>3. При необходимости проработать ошибочно отклоненные с проверяющим</li>
              </ul>
            </div>
            <!--rejectByRetoucher-->
            <div v-else-if="tab === 4">
              <div class="uk-text-bold">Отклонено ретушером</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет понимания причины отказов ретушеров.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Добавьте сортировку по уменьшению поля "Отклонено ретушером"</li>
                <li>3. Прорабатывайте причины отказа от заказа у ретушеров</li>
                <li>4. При необходимости давать ретушеру на проработку ту опцию, которую он не смог/отказался выполнить в этот раз</li>
              </ul>
            </div>
            <!--firstAndSecond-->
            <div v-else-if="tab === 5">
              <div class="uk-text-bold">1 и 2й заказы</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная точечная проверка 15 заказов на предмет целесообразности и актуальности назначения дополнительных функций.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов;</li>
                <li>2. Добавьте сортировку по уменьшению поля "Добавлены функции"</li>
                <li>3. Проверьте около 5 заказов, в которые добавили 3+ функций</li>
                <li>4. Проверьте около 5 заказов, в которые добавили 1-2 функции</li>
                <li>5. Проверьте около 5 заказов, в которые не было назначено дополнительных функций</li>
                <li>6. Сформируйте отчет в телеграме с информацией - номер заказа и краткий комментарий для дальнейшего пересмотра ошибок в этом разделе</li>
                <li>7. При возникновении сомнений, обсудите с Наташей, если все однозначно - проведите работу над ошибками с проверяющими</li>
              </ul>
            </div>
            <!--ordersDoneSenior-->
<!--            <div v-else-if="tab === 6">-->
<!--              7 таб ordersDoneSenior-->
<!--            </div>-->
            <!--ordersForcedClosed-->
            <div v-else-if="tab === 7">
              <div class="uk-text-bold">Принудительно закрытые</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет понимания причины закрытия заказов проверяющим.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Прорабатывайте причины закрытия заказа у проверяющих</li>
                <li>3. При необходимости проработать ошибочно закрытые с проверяющим</li>
              </ul>
            </div>
            <!--returnRetouchers-->
            <div v-else-if="currentTab === 'returnRetouchers'">
              <div class="uk-text-bold">Возврат ретушерам</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет адекватности работы админов и коррекции навыков ретушеров.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Добавьте сортировку по уменьшению поля "Всего переделок"</li>
                <li>3. Прорабатывайте причины переделок заказа у ретушеров</li>
                <li>4. При необходимости давать ретушеру на проработку ту опцию, которую он не смог/отказался выполнить в этот раз</li>
                <li>5. При необходимости проработайте с админами формулировки/адекватность написания комментариев</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--шапка-->
    <div class="uk-margin">
      <div class="uk-text-bold tm-history-grid-head uk-position-z-index uk-sticky"
           style="background-color: rgb(76, 175, 80); color: rgb(255, 255, 255);"
           data-uk-sticky="start: 200; animation: uk-animation-slide-top">
        <div class="uk-grid-collapse uk-flex-middle uk-grid" data-uk-grid>
          <div class="uk-width-auto">
            <div class="uk-grid-collapse uk-flex-middle uk-grid" data-uk-grid>
              <!-- 0 - Детали заказа -->
              <div style="width: 50px;">
                <div class="uk-padding-xsmall"></div>
              </div>
            </div>
          </div>
          <div class="uk-width-expand">
            <template v-if="currentTab === 'ordersAll'">
              <!-- таб ВСЕ ЗАКАЗЫ -->
              <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid tm-child-width-1-7" data-uk-grid>
                <!-- 1 - order_id - ID заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_id') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_id" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 2 - order_number - Номер заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_number') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_number" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 3 - ID_client - Клиент -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('ID_client') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="ID_client" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 4 - status - Статус -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('status') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="status" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 5 - process-retoucher - Сейчвас в работе-->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('process-retoucher') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="process-retoucher" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 6 - created_at - Заказ создан -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('created_at') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="created_at" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 7 - updated_at - Заказ обновлен -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('updated_at') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="updated_at" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="currentTab === 'ordersEducation'">
              <!-- таб ВСЕ ЗАКАЗЫ -->
              <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid uk-child-width-1-6" data-uk-grid>
                <!-- 1 - order_id - ID заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_id') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_id" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 2 - order_number - Номер заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_number') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_number" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
<!--                &lt;!&ndash; 3 - ID_client - Клиент &ndash;&gt;-->
<!--                <div>-->
<!--                  <div class="uk-padding-xsmall">-->
<!--                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>-->
<!--                      <div>-->
<!--                        {{ show_info_header('ID_client') }}-->
<!--                      </div>-->
<!--                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="ID_client" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash; 4 - status - Статус &ndash;&gt;-->
<!--                <div>-->
<!--                  <div class="uk-padding-xsmall">-->
<!--                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>-->
<!--                      <div>-->
<!--                        {{ show_info_header('status') }}-->
<!--                      </div>-->
<!--                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="status" @sortBy="onSortBy" v-if="tab === 0"></AdminOrderHistoryTableHeader>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash; 5 - process-retoucher - Сейчвас в работе&ndash;&gt;-->
<!--                <div>-->
<!--                  <div class="uk-padding-xsmall">-->
<!--                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>-->
<!--                      <div>-->
<!--                        {{ show_info_header('process-retoucher') }}-->
<!--                      </div>-->
<!--                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="process-retoucher" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <!-- 4 - Статус (latest_new_status) -->
                <div>
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('status') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="status" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 5 - process-retoucher - Сейчвас в работе-->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('process-retoucher') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="process-retoucher" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 6 - created_at - Заказ создан -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('created_at') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="created_at" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 7 - updated_at - Заказ обновлен -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('updated_at') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="updated_at" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="currentTab === 'regularCustomers'">
              <!-- таб ПОСТОЯННЫЕ КЛИЕНТЫ -->
              <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid tm-child-width-1-7" data-uk-grid>
                <!-- 1 - order_id - ID последнего заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_id') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_id" @sortBy="onSortBy" ></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 2 - order_number - Номер последнего заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_number') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_number" @sortBy="onSortBy" ></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 3 - ID_client - Клиент -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('ID_client') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="ID_client" @sortBy="onSortBy" ></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 4 - total_order_count - Всего заказов -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('total_order_count') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="total_order_count" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>

                <!-- 5 - avg_weeks_between_orders - Кол-во недель между заказами -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('avg_weeks_between_orders') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="avg_weeks_between_orders" @sortBy="onSortBy"/>
                    </div>
                  </div>
                </div>
                <!-- 6 - lost_client - Потерянный клиент -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('lost_client') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="lost_client" @sortBy="onSortBy"/>
                    </div>
                  </div>
                </div>
                <!-- 7 - created_at - Дата последнего заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('created_at') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="created_at" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="tab !== 0 && currentTab !== 'regularCustomers' && currentTab !== 'ordersUnviewed'">
              <!-- табы: Готово | В работе | Отклонено проверяющим | Отклонено ретушером | 1 и 2-й заказы | Проверены сеньором | Принудительно закрытые | Возврат ретушерам  -->
              <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid" data-uk-grid :class="orderListGetTabClass">
                <!-- 1 - order_id - ID заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_id') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_id" @sortBy="onSortBy" v-if="tab !== 0"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 2 - Номер заказа (order_number_in_sys) -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_number') }}
                        <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_number" @sortBy="onSortBy" v-if="tab !== 0"></AdminOrderHistoryTableHeader>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 3 - ID_client - Клиент -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('ID_client') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="ID_client" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 4 - Статус (latest_new_status) -->
                <div>
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('status') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="status" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 5 - В работе (user_now) -->
                <div>
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('user_now') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="user_now" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!--Проверка сеньором-->
                <div v-if="currentTab !== 'ordersInWork'">
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('check_senior') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="senior_retoucher_quality" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 6 - От создания (minutes_from_create) -->
                <div v-if="currentTab !== 'returnRetouchers'">
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('minutes_from_create') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="minutes_from_create" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 7 - От активности клиента (min_spent_on_order) -->
                <div>
                  <div v-if="tab !== 1" class="uk-padding-xsmall">
                    {{ show_info_header('min_spent_on_order') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="min_spent_on_order" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                  <div v-if="tab === 1" class="uk-padding-xsmall">
                    {{ show_info_header('min_spent_on_order') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="time_difference_in_minutes" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 8 - Дата создания (order_created_time) -->
                <div>
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('order_created_time') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_created_time" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 9 - Дата активности клиента (latest_activity) -->
                <div v-if="currentTab !== 'returnRetouchers'">
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('latest_activity') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="latest_activity" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 10 - Последняя активность (last_customer_activity) -->
                <div v-if="currentTab !== 'returnRetouchers'">
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('last_customer_activity') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="lastcustomeractivity" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 11 - Добавленные функции. Только для 1 и 2 -->
                <div v-if="currentTab === 'firstAndSecond'">
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('table_header_added_functions') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="added_functions" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <!-- 11 - Отклонено ретушером -->
                <div v-if="currentTab === 'rejectByRetoucher'">
                  <div class="uk-padding-xsmall">
                    {{ show_info_header('table_header_rejected_retoucher_count') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="rejected_retoucher_records_count" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <div v-if="currentTab === 'returnRetouchers'">
                  <div class="uk-padding-xsmall" data-uk-tooltip="Число возвратов ретушерам в процессе работы над заказом до отправки клиенту">
                    {{ show_info_header('table_header_rejected_max_rejects') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="max_rejects" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
                <div v-if="currentTab === 'returnRetouchers'">
                  <div class="uk-padding-xsmall" data-uk-tooltip="Общее число возвратов ретушерам. Тут могут быть учтены все версии над которыми работали до отправки клиенту и после возврата от клиента">
                    {{ show_info_header('table_header_rejected_total_rejects') }}
                    <AdminOrderHistoryTableHeader :sort_by="sort_by" value="total_rejects" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="currentTab === 'ordersUnviewed'">
              <!-- таб НЕПРОСМОТРЕННЫЕ ЗАКАЗЫ -->
              <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid tm-child-width-1-8" data-uk-grid>
              <!-- 1 - order_id - ID последнего заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_id') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_id" @sortBy="onSortBy" ></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 2 - order_number - Номер последнего заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('order_number') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="order_number" @sortBy="onSortBy" ></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 3 - ID_client - Клиент -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('ID_client') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="ID_client" @sortBy="onSortBy" ></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 4 - phone_location_country_ISO - Страна  -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('phone_location_country_ISO') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="phone_location_country_ISO" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 5 - minutes_for_client - Кол-во минут для клиента -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('minutes_for_client') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="minutes_for_client" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 6 - minutes_for_order_in_work - Кол-во минут в работе -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('minutes_for_order_in_work') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="minutes_for_order_in_work" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 7 - open_app_after_create_order - Открытие приложения после готовности заказа -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('open_app_after_create_order') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="open_app_after_create_order" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
                <!-- 8 - created_at - Заказ создан -->
                <div>
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        {{ show_info_header('created_at') }}
                      </div>
                      <AdminOrderHistoryTableHeader :sort_by="sort_by" value="created_at" @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!--список-->
    <div class="uk-grid-collapse uk-grid uk-child-width-1-1 uk-grid-divider tm-history-grid" data-uk-grid>
      <template v-if="loading">
        <div>
          <div class="uk-padding-xsmall">
            <v-progress-circular
                :width="2"
                indeterminate
                style="color: forestgreen"></v-progress-circular>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-for="order of tableList" :key="order.id">
          <div>
            <div class="uk-grid-collapse uk-flex-middle uk-grid tm-grid-bg-hover" data-uk-grid>
              <div class="uk-width-auto">
                <div class="uk-grid-collapse uk-flex-middle uk-grid" data-uk-grid>
                  <!-- 0 - Детали заказа -->
                  <div style="width: 50px;">
                    <div class="uk-padding-xsmall">
                      <a :href="'#'+order.order_id"
                         @click="$emit('openOrder', { orderId: order.order_id, currentTab:currentTab, tabList:tableList })"
                         data-uk-tooltip="Детальный вид/история заказа"
                        class="tm-link-visited uk-link-reset">
                        <span class="uk-icon"><svg width="26" height="26" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="15 10.5 15 17 3 17 3 5 9.5 5"></polyline><line fill="none" stroke="#000" x1="8.22" y1="11.79" x2="17.01" y2="2.99"></line><polyline fill="none" stroke="#000" points="12.5 3 17 3 17 7.5"></polyline></svg></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="uk-width-expand">
                <template v-if="currentTab === 'ordersAll'">
                  <!-- таб ВСЕ ЗАКАЗЫ -->
                  <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid tm-child-width-1-7" data-uk-grid>
                    <!-- 1 - order_id - ID заказа -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ order.order_id }}
                      </div>
                    </div>
                    <!-- 2 - order_number - Номер заказа -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-truncate" :data-uk-tooltip="show_info('order_number', order).content">
                        {{ show_info('order_number', order).content}}
                      </div>
                    </div>
                    <!-- 3 - ID_client - Клиент -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-left">
                        <div class="uk-grid tm-grid-xsmall" data-uk-grid>
                          <div class="uk-width-auto">
                            <a class="uk-link-reset uk-display-block" :href="getUrlClientAnalytics( order.ID_client)" target="_blank" data-uk-tooltip="Проанализировать клиента">
                              <md-icon>manage_search</md-icon>
                            </a>
                          </div>
                          <div class="uk-width-expand">
                            <a href="#" @click.prevent="sortByClient(show_info('ID_client', order).content)" class="uk-link-reset uk-text-truncate uk-display-block" :data-uk-tooltip="show_info('ID_client', order).content">
                              <md-icon>filter_list</md-icon>
                              {{ show_info('ID_client', order).content }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 4 - status - Статус -->
                    <div>
                      <div class="uk-padding-xsmall">
                         <span
                             v-if="order.status"
                             :data-uk-tooltip="'title: ' + local_page_keys[ 'status_description_' + order.status.replace(/-/g, '_')] + '; offset: 5; pos: right'">
                          {{ order.status }}
                         </span>
                        <span v-if="order.status && checkedOrder(order)">
                            <md-icon>{{ whichIcon(order.senior_retoucher_quality) }}</md-icon>
                        </span>
                        <button v-else-if="order.status && order.status.includes('broken')"
                                @click="$emit('show_info_broken', order)">
                          <md-icon>help</md-icon>
                        </button>
                      </div>
                    </div>
                    <!-- 5 - process-retoucher - Сейчвас в работе-->
                    <div>
                      <div class="uk-padding-xsmall uk-text-truncate" :data-uk-tooltip="show_info('process-retoucher', order).content">
                      <span v-if="order.process_retoucher">
                        {{ show_info('process-retoucher', order).content}}
                      </span>
                      </div>
                    </div>
                    <!-- 6 - created_at - Заказ создан -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('created_at', order).content}}
                      </div>
                    </div>
                    <!-- 7 - updated_at - Заказ обновлен -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('updated_at', order).content}}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="currentTab === 'regularCustomers'">
                  <!-- таб ПОСТОЯННЫЕ КЛИЕНТЫ -->
                  <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid tm-child-width-1-7" data-uk-grid>
                    <!-- 1 - order_id - ID последнего заказа  -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ order.order_id }}
                      </div>
                    </div>
                    <!-- 2 - order_number - Номер последнего заказа -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-truncate" :data-uk-tooltip="show_info('order_number', order).content">
                        {{ show_info('order_number', order).content}}
                      </div>
                    </div>
                    <!-- 3 - ID_client - Клиент -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-left">
                        <div class="uk-grid tm-grid-xsmall" data-uk-grid>
                          <div class="uk-width-auto">
                            <a class="uk-link-reset uk-display-block" :href="getUrlClientAnalytics( order.ID_client)" target="_blank" data-uk-tooltip="Проанализировать клиента">
                              <md-icon>manage_search</md-icon>
                            </a>
                          </div>
                          <div class="uk-width-expand">
                            <a href="#" @click.prevent="sortByClient(show_info('ID_client', order).content)" class="uk-link-reset uk-text-truncate uk-display-block" :data-uk-tooltip="show_info('ID_client', order).content">
                              <md-icon>filter_list</md-icon>
                              {{ show_info('ID_client', order).content }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 4 - total_order_count - Всего заказов -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-truncate" :data-uk-tooltip="show_info('total_order_count', order).content">
                      <span v-if="order.total_order_count">
                        {{ show_info('total_order_count', order).content}}
                      </span>
                      </div>
                    </div>

                    <!-- 5 - avg_weeks_between_orders - Кол-во недель между заказами -->
                    <div>
                      <div class="uk-padding-xsmall">
                            {{ show_info('avg_weeks_between_orders', order).content }}
                      </div>
                    </div>
                    <!-- 6 - lost_client - Потерянный клиент -->
                    <div>
                      <div class="uk-padding-xsmall">
                           <span v-if="order.lost_client">
                              <md-icon class="tm-senior-mark-ico tm-icon-close">close</md-icon>
                           </span>
                      </div>
                    </div>

                    <!-- 5 - created_at - Дата последнего заказа -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('created_at', order).content}}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="currentTab === 'ordersEducation'">
                  <!-- таб education ЗАКАЗЫ -->
                  <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid uk-child-width-1-6" data-uk-grid>
                    <!-- 1 - order_id - ID заказа -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ order.order_id }}
                      </div>
                    </div>
                    <!-- 2 - order_number - Номер заказа -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-truncate-" :data-uk-tooltip="show_info('order_number', order).content">
                        {{ show_info('order_number', order).content}}
                      </div>
                    </div>
<!--                    &lt;!&ndash; 3 - ID_client - Клиент &ndash;&gt;-->
<!--                    <div>-->
<!--                      <div class="uk-padding-xsmall uk-text-left">-->
<!--                        <a href="#" @click="sortByClient(show_info('ID_client', order).content)" class="uk-link-reset uk-text-truncate uk-display-block" :data-uk-tooltip="show_info('ID_client', order).content">-->
<!--                          <md-icon>filter_list</md-icon>-->
<!--                          {{ show_info('ID_client', order).content }}-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; 4 - status - Статус &ndash;&gt;-->
<!--                    <div>-->
<!--                      <div class="uk-padding-xsmall">-->
<!--                         <span-->
<!--                             v-if="order.status"-->
<!--                             :data-uk-tooltip="'title: ' + local_page_keys[ 'status_description_' + order.status.replace(/-/g, '_')] + '; offset: 5; pos: right'">-->
<!--                          {{ order.status }}-->
<!--                         </span>-->
<!--                        <span v-if="order.status && checkedOrder(order)">-->
<!--                            <md-icon>{{ whichIcon(order.senior_retoucher_quality) }}</md-icon>-->
<!--                        </span>-->
<!--                        <button v-else-if="order.status && order.status.includes('broken')"-->
<!--                                @click="$emit('show_info_broken', order)">-->
<!--                          <md-icon>help</md-icon>-->
<!--                        </button>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; 5 - process-retoucher - Сейчвас в работе&ndash;&gt;-->
<!--                    <div>-->
<!--                      <div class="uk-padding-xsmall uk-text-truncate" :data-uk-tooltip="show_info('process-retoucher', order).content">-->
<!--                      <span v-if="order.process_retoucher">-->
<!--                        {{ show_info('process-retoucher', order).content}}-->
<!--                      </span>-->
<!--                      </div>-->
<!--                    </div>-->
                    <!-- 4 - Статус (latest_new_status) -->
                    <div>
                      <div class="uk-padding-xsmall">
                        <div class="uk-text-truncate">
                          <span v-if="order.latest_new_status" :data-uk-tooltip="'title: ' + local_page_keys[ 'status_description_' + order.latest_new_status.replace(/-/g, '_')] + '; offset: 5; pos: right'">
                            {{ order.latest_new_status }}
                          </span>
                          <span v-else-if="order.last_status" :data-uk-tooltip="'title: ' + local_page_keys[ 'status_description_' + order.last_status.replace(/-/g, '_')] + '; offset: 5; pos: right'">
                            {{ order.last_status }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- 5 - process-retoucher - Сейчвас в работе-->
                    <div>
                      <div class="uk-padding-xsmall uk-text-truncate" :data-uk-tooltip="show_info('process-retoucher', order).content">
                      <span v-if="order.education_retoucher_email">
                        {{order.education_retoucher_email}}
                      </span>
                      </div>
                    </div>
                    <!-- 6 - created_at - Заказ создан -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('created_at', order).content}}
                      </div>
                    </div>
                    <!-- 7 - updated_at - Заказ обновлен -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('updated_at', order).content}}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="tab !== 0 && currentTab !== 'regularCustomers' && currentTab !== 'ordersUnviewed'">
                  <!-- табы: Готово | В работе | Отклонено проверяющим | Отклонено ретушером | 1 и 2-й заказы -->
                  <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid" data-uk-grid :class="orderListGetTabClass">
                    <!-- 1 - order_id - ID заказа -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ order.order_id }}
                      </div>
                    </div>
                    <!-- 2 - Номер заказа (order_number_in_sys) -->
                    <div>
                      <div class="uk-padding-xsmall">
                        <div>
                          {{ order.order_number_in_sys }}
                        </div>
                      </div>
                    </div>
                    <!-- 3 - ID_client - Клиент -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-left uk-text-truncate" :data-uk-tooltip="show_info('ID_client', order).content">
                        <div class="uk-grid tm-grid-xsmall" data-uk-grid>
                          <div class="uk-width-auto">
                            <a class="uk-link-reset uk-display-block" :href="getUrlClientAnalytics( order.ID_client)" target="_blank" data-uk-tooltip="Проанализировать клиента">
                              <md-icon>manage_search</md-icon>
                            </a>
                          </div>
                          <div class="uk-width-expand">
                            {{ show_info('ID_client', order).content }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 4 - Статус (latest_new_status) -->
                    <div>
                      <div class="uk-padding-xsmall">
                        <div class="uk-text-truncate">
                          <span v-if="order.latest_new_status" :data-uk-tooltip="'title: ' + local_page_keys[ 'status_description_' + order.latest_new_status.replace(/-/g, '_')] + '; offset: 5; pos: right'">
                            {{ order.latest_new_status }}
                          </span>
                          <span v-else-if="order.last_status" :data-uk-tooltip="'title: ' + local_page_keys[ 'status_description_' + order.last_status.replace(/-/g, '_')] + '; offset: 5; pos: right'">
                            {{ order.last_status }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- 5 - В работе (user_now) -->
                    <div>
                      <div class="uk-padding-xsmall">
                        <div class="uk-text-truncate" :data-uk-tooltip="order.user_now">
                          {{ order.user_now }} {{ order.user }}
                        </div>
                      </div>
                    </div>
                    <!-- 6 - Проверка сеньором-->
                    <div v-if="currentTab !== 'ordersInWork'">
                      <div class="uk-padding-xsmall"  >
                        {{ order.senior_retoucher_quality }}
                      </div>
                    </div>
                    <!-- 7 - От создания (minutes_from_create) -->
                    <div v-if="currentTab !== 'returnRetouchers'">
                      <div class="uk-padding-xsmall">
                        <div>
                          {{ order.minutes_from_create }}
                        </div>
                      </div>
                    </div>
                    <!-- 8 - От активности клиента (min_spent_on_order) -->
                    <div>
                      <div class="uk-padding-xsmall">
                        <div v-if="tab !== 1">
                          {{ order.min_spent_on_order }}
                        </div>
                        <div v-else-if="tab === 1">
                          {{ order.time_difference_in_minutes }}
                        </div>
                      </div>
                    </div>
                    <!-- 9 - Дата создания (order_created_time) -->
                    <div>
                      <div class="uk-padding-xsmall">
                        <div>
                          {{ order.order_created_time }}
                        </div>
                      </div>
                    </div>
                    <!-- 10 - Дата активности клиента (latest_activity) -->
                    <div v-if="currentTab !== 'returnRetouchers'">
                      <div class="uk-padding-xsmall">
                        <div>
                          {{ order.latest_activity }}
                        </div>
                      </div>
                    </div>
                    <!-- 11 - Последняя активность (last_customer_activity) -->
                    <div v-if="currentTab !== 'returnRetouchers'">
                      <div class="uk-padding-xsmall">
                        <div>
                          {{ order.lastcustomeractivity }}
                        </div>
                      </div>
                    </div>
                    <!-- 12 - Добавленные функции. Только для 1 и 2 -->
                    <div v-if="currentTab === 'firstAndSecond'">
                      <div class="uk-padding-xsmall">
                        <div>
                          {{ order.added_functions }}
                        </div>
                      </div>
                    </div>
                    <!-- 12 - Отклонено ретушером -->
                    <div v-if="currentTab === 'rejectByRetoucher'">
                      <div class="uk-padding-xsmall">
                        <div>
                          {{ order.rejected_retoucher_records_count }}
                        </div>
                      </div>
                    </div>

                    <div v-if="currentTab === 'returnRetouchers'">
                      <div class="uk-padding-xsmall">
                        {{ order.max_rejects}}
                      </div>
                    </div>
                    <div v-if="currentTab === 'returnRetouchers'">
                      <div class="uk-padding-xsmall">
                        {{ order.total_rejects}}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="currentTab === 'ordersUnviewed'">
                  <!-- таб НЕПРОСМОТРЕННЫЕ ЗАКАЗЫ -->
                  <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid tm-child-width-1-8" data-uk-grid>
                    <!-- 1 - order_id - ID последнего заказа  -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ order.order_id }}
                      </div>
                    </div>
                    <!-- 2 - order_number - Номер последнего заказа -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-truncate" :data-uk-tooltip="show_info('order_number', order).content">
                        {{ show_info('order_number', order).content}}
                      </div>
                    </div>
                    <!-- 3 - ID_client - Клиент -->
                    <div>
                      <div class="uk-padding-xsmall uk-text-left">
                        <div class="uk-grid tm-grid-xsmall" data-uk-grid>
                          <div class="uk-width-auto">
                            <a class="uk-link-reset uk-display-block" :href="getUrlClientAnalytics( order.ID_client)" target="_blank" data-uk-tooltip="Проанализировать клиента">
                              <md-icon>manage_search</md-icon>
                            </a>
                          </div>
                          <div class="uk-width-expand">
                            <a href="#" @click.prevent="sortByClient(show_info('ID_client', order).content)" class="uk-link-reset uk-text-truncate uk-display-block" :data-uk-tooltip="show_info('ID_client', order).content">
                              <md-icon>filter_list</md-icon>
                              {{ show_info('ID_client', order).content }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 4 - phone_location_country_ISO - Страна  -->
                    <div>
                      <div class="uk-padding-xsmall">
                         {{ show_info('phone_location_country_ISO', order).content }}
                      </div>
                    </div>
                    <!-- 5 - minutes_for_client - Кол-во минут для клиента -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('minutes_for_client', order).content }}
                      </div>
                    </div>
                    <!-- 6 - minutes_for_order_in_work - Кол-во минут в работе -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('minutes_for_order_in_work', order).content }}
                      </div>
                    </div>
                    <!-- 7 - open_app_after_create_order - Открытие приложения после готовности заказа -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('open_app_after_create_order', order).content }}
                      </div>
                    </div>
                    <!-- 8 - created_at - Заказ создан -->
                    <div>
                      <div class="uk-padding-xsmall">
                        {{ show_info('created_at', order).content }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!--пагинация-->
    <template v-if="paginated.total_entries !== 0">
      <hr class="uk-margin-medium-bottom">
      <div class="uk-grid uk-flex-middle" data-uk-grid v-if="showpagination">
        <div class="uk-width-expand">
          {{ paginated.from_entries }}-{{ paginated.to_entries }} {{ local_page_keys.pagination_lable_of }} {{ paginated.total_entries }} {{ local_page_keys.pagination_entries }}
        </div>
        <div>
          <ul class="uk-pagination tm-pagination uk-flex-center uk-flex-middle">
            <li :class="(pagination.currentPage === 1 ? 'uk-disable' : '')">
              <button type="button"
                      class="uk-link-reset"
                      @click="goToPrevious()"
                      :disabled="pagination.currentPage === 1">
                <span data-uk-pagination-previous></span>
              </button>
            </li>
            <li class="uk-active"><span>{{ currentPage }}</span></li>
            <li>
              <input class="uk-input" style="width: 40px;margin: 0 5px;" data-uk-tooltip="Переход на страницу" v-model="pageNumber" @input="goToPage()">
            </li>
            <li>
              page of {{ paginated.total_page }}
            </li>
            <li :class="(pagination.currentPage >= pagination.totalPages ? 'uk-disable' : '')">
              <button type="button"
                      class="uk-link-reset"
                      @click="goToNext()"
                      :disabled="pagination.currentPage === paginated.last_page">
                <span data-uk-pagination-next></span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="uk-text-center uk-padding">
        результаты не найдены
      </div>
    </template>
  </div>
</template>

<script>
import filter_table_admin_orders_history from "../../../filters/filter_table_admin_orders_history";
import AdminOrderHistoryTableHeader from "./AdminOrderHistoryTableHeader.vue";
import DatepickerDialog from "./Admin/DatepickerDialog.vue";

export default {
  name: "AdminOrderHistoryTable",
  components: {DatepickerDialog, AdminOrderHistoryTableHeader},
  filters: {filter_table_admin_orders_history},
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    ordersHistoryList: {
      type: Object,
      require: true,
    },
    headers: {
      type: Array,
      require: true
    },
    tab: {
      require: true
    },
    tabs: {
      type: Array,
      require: true
    },
    showForClient: {
      type: String,
      require: true
    },
    searchInArchive: {
      type: Object,
      require: true
    }
  },
  data: () => ({
    paginated: {
      last_page: 1,
      from_entries: 1,
      to_entries: 1,
      total_entries: 1,
      total_page: 1
    },
    pagination: {
      perPage: 10,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 500],
    },
    changedList: [],
    sort_by: {
      column: 'created_at',
      order: 'desc'
    },
    showDateRangePiecker: false,
    choosenPeriod: [],
    choosenRole: '',
    roles: [
      {
        text: "pro-retouchers",
        value: "pro-retoucher"
      },
      {
        text: "retouchers",
        value: "retoucher"
      }
    ],
    statuses: [
      {
        text: "new_order",
        value: "new"
      },
      {
        text: "hold_retoucher",
        value: "hold-retoucher"
      },
      {
        text: "hold_admin",
        value: "hold-admin"
      },
      {
        text: "re_done_customer",
        value: "re-done-customer"
      },
      {
        text: "rejected_admin_to_retoucher",
        value: "rejected-admin-to-retoucher"
      },
      {
        text: "re_done_admin",
        value: "re-done-admin"
      },
      {
        text: "done_retoucher",
        value: "done-retoucher"
      },
      {
        text: "rejected_retoucher",
        value: "rejected-retoucher"
      },
      {
        text: "broken",
        value: "broken"
      },
      {
        text: "rejected_admin",
        value: "rejected-admin"
      },
      {
        text: "done_admin",
        value: "done-admin"
      }
    ],
    choosenStatus: [],
    todayDate: '',
    selectedDateField: '',
    options_for_select_sort_for_orders_tab: [
      {value: 'create_update_period', text: 'select_option_for_sort_by_create_update_period'},
      {value: 'worker', text: 'select_option_for_sort_by_worker'},
      {value: 'status', text: 'select_option_for_sort_by_status'}
    ],
    options_for_select_sort_for_orders_education_tab: [
      {value: 'all', text: 'select_option_for_sort_by_worker_all'},
      {value: 'completed', text: 'select_option_for_sort_by_worker_completed'},
      {value: 'in_work', text: 'select_option_for_sort_by_worker_in_work'}
    ],
    options_for_select_sort_for_done_orders_tab: [
      {value: 'create_update_period', text: 'select_option_for_sort_by_create_update_period'},
      {value: 'worker', text: 'select_option_for_sort_by_worker'},
    ],
    selectSortOption: '',
    selectSortOptionEducation: 'all',
    chosenUsers: [],
    users_for_history: [],
    searchByOrderNumber: '',
    sorted_mode: '',
    showpagination: true,
    pageNumber: '',
    loading: false,
    showForClientInt: false
  }),
  methods: {
    async goToPrevious() {
      this.pagination.currentPage--;
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },
    async goToNext() {
      this.pagination.currentPage++;
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },
    async goToPage() {
      this.pagination.currentPage = this.pageNumber;
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },

    show_info(header, value) {
      return filter_table_admin_orders_history(header, value);
    },
    show_info_header(value) {
      const item = this.headers.find((item) => item.value === value);
      return item ? item.text : '';
    },
    checkedOrder(order) {
      return order.status === 'done-admin' && order.senior_retoucher_status !== null;
    },
    whichIcon(quality) {
      let senRetQualityIcon = '';
      switch (quality) {
        case 'bad-job':
          senRetQualityIcon = 'thumb_down';
          break;
        case 'nice-job':
          senRetQualityIcon = 'thumb_up';
          break;
      }

      return senRetQualityIcon;
    },
    sortByClient(client) {
      this.$emit('sort_by_client', client)
    },
    async getOrdersHistoryList() {
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        archive: this.searchInArchive[this.currentTab]
      }

      let data;
      this.loading = true;
      this.changedList = [];
      this.showForClientInt = false;

      if (this.showForClient === '') {
        await this.$store.dispatch('adminOrdersHistory/tadOrdersList', params);
        data = await this.$store.getters['adminOrdersHistory/tadOrdersList'];
      } else {
        params['client_id'] = this.showForClient;
        this.showForClientInt = true;
        await this.$store.dispatch('adminOrdersHistory/tadOrdersListByClientId', params);
        data = await this.$store.getters['adminOrdersHistory/tadOrdersListByClientId'];
      }
      if (typeof data === 'object' && data.status === "success") {
        this.pagination.currentPage = data['orders'].current_page;
        this.pagination.perPage = data['orders'].per_page;
        this.paginated.from_entries = data['orders'].from;
        this.paginated.to_entries = data['orders'].to;
        this.paginated.last_page = data['orders'].last_page;
        this.paginated.total_entries = data['orders'].total;
        this.paginated.total_page = data['orders'].last_page;
        this.changedList = Object.values(data['orders'].data);

      } else {
        alert(data);
      }
      this.loading = false;
    },
    async onSortBy(data) {
      let column = data.column;
      let order = data.order;
      if (this.sort_by.column === column) {
        this.sort_by.order = order === 'desc' ? 'asc' : 'desc';
      } else {
        this.sort_by.column = column;
        this.sort_by.order = order;
      }
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }

    },
    getPeriod() {
      this.choosenPeriod.sort();
    },
    clearSelectedOptions() {
      this.selectedDateField = '';
      this.choosenPeriod = [];
      this.choosenRole = '';
      this.chosenUsers = [];
    },
    selectSortOptionEducationAction(){
      this.getOrdersHistoryByPeriod();
    },
    async showUserSelect() {
      this.users_for_history = [];
      this.chosenUsers = [];
      try {
        let roles = [this.choosenRole];
        await this.$store.dispatch("users/chosenRolesUsersList", {roles});
        this.users_for_history = await this.$store.getters['users/chosenRolesUsersList'];
      } catch (e) {
        alert(this.local_page_keys.alert_something_went_wrong)
      }
    },
    async getSearchByOrderNumber() {
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        order_number: this.searchByOrderNumber,
        archive: this.searchInArchive[this.currentTab]
      }
      this.loading = true;
      if (this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        if (this.showForClient !== '') params['client_id'] = this.showForClient;
        await this.$store.dispatch('adminOrdersHistory/tabSearchOrdersList', params)
        let data = await this.$store.getters['adminOrdersHistory/tabSearchOrdersList'];
        if (typeof data === 'object' && data.status === "success") {
          this.changedList = [];
          this.pagination.currentPage = data['orders'].current_page;
          this.pagination.perPage = data['orders'].per_page;
          this.paginated.from_entries = data['orders'].from;
          this.paginated.to_entries = data['orders'].to;
          this.paginated.last_page = data['orders'].last_page;
          this.paginated.total_entries = data['orders'].total;
          this.paginated.total_page = data['orders'].last_page;
          this.changedList = Object.values(data['orders'].data);
        } else {
          alert(this.local_page_keys.alert_something_went_wrong);
        }
        this.loading = false;
      }
    },
    async changeListLength() {
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },
    async getWorkerPeriodInfo() {
      let users = this.chosenUsers.filter((el)=> {return el !=='';})
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        user_ids: users,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        archive: this.searchInArchive[this.currentTab]
      }
      if (this.showForClient !== '') {
        params['client_id'] = this.showForClient;
      }
      if (this.searchByOrderNumber !== '') {
        params['order_number'] = this.searchByOrderNumber;
      }
      this.loading = true;
      await this.$store.dispatch('adminOrdersHistory/workersTabPeriod', params);
      let data = await this.$store.getters['adminOrdersHistory/workersTabPeriod'];
      this.sorted_mode = 'workers_period';
      if (typeof data === 'object' && data.status === "success") {
        this.changedList = [];
        this.pagination.currentPage = data[this.currentTab].current_page;
        this.pagination.perPage = data[this.currentTab].per_page;
        this.paginated.from_entries = data[this.currentTab].from;
        this.paginated.to_entries = data[this.currentTab].to;
        this.paginated.last_page = data[this.currentTab].last_page;
        this.paginated.total_entries = data[this.currentTab].total;
        this.paginated.total_page = data[this.currentTab].last_page;
        this.changedList = data[this.currentTab].data;
        this.showpagination = true;
      } else {
        this.showpagination = false;
        this.changedList = [];
        alert(data);
      }
      this.loading = false;
    },
    async getOrdersHistoryByPeriod() {
      let users = this.chosenUsers.filter((el)=> {return el !=='';})

      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        field: this.selectedDateField,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        selectSortOptionEducation: this.selectSortOptionEducation,
        archive: this.searchInArchive[this.currentTab]
      }
      if(users.length > 0){
        params['user_ids'] = users;
      }
      if (this.showForClient !== '') {
        params['client_id'] = this.showForClient;
      }
      if (this.searchByOrderNumber !== '') {
        params['order_number'] = this.searchByOrderNumber;
      }
      if(this.currentTab == 'ordersEducation'){
        params['page'] = 1;
        this.pagination.currentPage = 1;
        this.pageNumber = 1;
      }
      this.loading = true;
      await this.$store.dispatch('adminOrdersHistory/historyByPeriod', params);
      let data = await this.$store.getters['adminOrdersHistory/historyByPeriod'];
      this.sorted_mode = 'history_by_period';
      if (typeof data === 'object' && data.status === "success") {
        this.changedList = [];
        this.pagination.currentPage = data['orders'].current_page;
        this.pagination.perPage = data['orders'].per_page;
        this.paginated.from_entries = data['orders'].from;
        this.paginated.to_entries = data['orders'].to;
        this.paginated.last_page = data['orders'].last_page;
        this.paginated.total_entries = data['orders'].total;
        this.paginated.total_page = data['orders'].last_page;
        this.changedList = Object.values(data['orders'].data);
        this.showpagination = true;
      } else {
        this.showpagination = false;
        this.changedList = [];
        alert(data);
      }
      this.loading = false;
    },
    async getSortByStatus() {
      if (this.choosenStatus.includes('broken')) {
        let broken_statuses = ['broken', 'broken_finances_at_creating', 'broken_finances_at_set_free_order_for_retoucher']
        for (let brok_status of broken_statuses) {
          this.choosenStatus.push(brok_status);
        }
      }
      let statuses = this.choosenStatus.reduce((prev, cur) => (prev.indexOf(cur) === -1) ? [...prev, cur] : prev, []);
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        statuses: statuses,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        archive: this.searchInArchive[this.currentTab]
      }
      if (this.showForClient !== '') {
        params['client_id'] = this.showForClient;
      }
      if (this.searchByOrderNumber !== '') {
        params['order_number'] = this.searchByOrderNumber;
      }
      this.loading = true;
      await this.$store.dispatch('adminOrdersHistory/historyByStatuses', params);
      let data = this.$store.getters['adminOrdersHistory/historyByStatuses'];
      this.sorted_mode = 'history_by_statuses';
      if (typeof data === 'object' && data.status === "success") {
        this.changedList = [];
        this.pagination.currentPage = data[this.currentTab].current_page;
        this.pagination.perPage = data[this.currentTab].per_page;
        this.paginated.from_entries = data[this.currentTab].from;
        this.paginated.to_entries = data[this.currentTab].to;
        this.paginated.last_page = data[this.currentTab].last_page;
        this.paginated.total_entries = data[this.currentTab].total;
        this.paginated.total_page = data[this.currentTab].last_page;
        this.changedList = data[this.currentTab].data;
        this.showpagination = true;
      } else {
        this.showpagination = false;
        this.changedList = [];
        alert(data);
      }
      this.loading = false;

    },
    async checkmethod() {
      if (this.sorted_mode === '') {
        await this.getSearchByOrderNumber();
      } else if(this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if(this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if(this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      }
    },
    clearSearchField() {
      this.searchByOrderNumber = '';
      this.getOrdersHistoryList();
    },
    toggleDateRangePicker() {
      this.showDateRangePicker = !this.showDateRangePicker;
    },
    async archiveChecker(event){
       this.$emit('update:search-in-archive', event.target.checked);
     //  await this.getOrdersHistoryList()
       await this.checkmethod();
    },
    getUrlClientAnalytics(ID_client) {
      const urlClientAnalytics = this.$router.resolve({
        name: 'ClientAnalytics',
      }).href;

      const fullUrl = `${window.location.origin}${urlClientAnalytics}`;

      let url = new URL(fullUrl);
      url.searchParams.set('clientId', ID_client);
      url.searchParams.set('perPage', 500);
      url.searchParams.set('date_start', this.choosenPeriod[0] ?  this.choosenPeriod[0] + ' 00:00:00' : '');
      url.searchParams.set('date_end', this.choosenPeriod[1] ? this.choosenPeriod[1] + ' 23:59:59' : '');

      return url.toString();
    }
  },
  computed: {
    currentTab() {
      return this.tabs[this.tab].value;
    },
    tableList() {
      //return this.changedList.length === 0 && this.searchByOrderNumber === '' && this.sorted_mode === '' && this.showForClient === '' ? this.ordersHistoryList.data : this.changedList;
      return this.changedList.length === 0 && this.searchByOrderNumber === '' && this.sorted_mode === '' && !this.showForClientInt  ? this.ordersHistoryList.data : this.changedList;
    },
    currentPage() {
      return this.changedList.length > 0 ? this.pagination.currentPage : this.ordersHistoryList.current_page;
    },
    per_page() {
      return this.changedList.length > 0 ? this.pagination.perPage : this.ordersHistoryList.per_page;
    },
    dateTimePeriod() {
      return this.choosenPeriod.length > 0 ? this.choosenPeriod[0] + '~' + this.choosenPeriod[1] : '';
    },
    showShowWorkerButton() {
      return this.chosenUsers.length === 1 && this.chosenUsers.includes('') ? false : this.chosenUsers.length > 0;
    },
    showStatusButton() {
      return this.choosenStatus.length === 1 && this.choosenStatus.includes('') ? false : this.choosenStatus.length > 0;
    },
    formattedStatuses() {
      return this.statuses.map(status => ({
        value: status.value,
        text: this.local_page_keys[ 'option_select_status_' + status.text]
      }));
    },
    formattedUserForHistory() {
      const users = Object.values(this.users_for_history);
      return users.map(user => ({
        value: user.id,
        text: (user.name !== '' ? user.name : user.email) + '(' + user.email + ' ' + user.role + ')'
      }))
    },
    orderListGetTabClass() {
      if (this.currentTab === 'firstAndSecond') {
        return 'tm-child-width-1-12';
      } else if (this.currentTab === 'rejectByRetoucher') {
        return 'tm-child-width-1-12';
      } else if (this.currentTab === 'returnRetouchers') {
        return 'tm-child-width-1-10';
      } else if (this.currentTab === 'ordersInWork') {
        return 'tm-child-width-1-10';
      } else {
        return 'tm-child-width-1-11';
      }
    },
  },
  created() {
    let today = new Date().toJSON();
    this.todayDate = today.slice(0, today.indexOf('T'))
    this.pagination.currentPage = this.ordersHistoryList.current_page;
    this.pagination.perPage = this.ordersHistoryList.per_page;
    this.paginated.from_entries = this.ordersHistoryList.from;
    this.paginated.to_entries = this.ordersHistoryList.to;
    this.paginated.last_page = this.ordersHistoryList.last_page;
    this.paginated.total_entries = this.ordersHistoryList.total;
    this.paginated.total_page = this.ordersHistoryList.last_page;

    if (this.tab !== 0 ) {
      let currentDate = new Date();
      let formattedDateEnd = currentDate.getFullYear() + '-' + ((currentDate.getMonth() + 1) < 10 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
      let dateToWeek = new Date(); // Создаем новый объект Date для начальной даты
      dateToWeek.setDate(currentDate.getDate() - 1); // Устанавливаем начальную дату на неделю назад
      let formattedDateStart = dateToWeek.getFullYear() + '-' + ((dateToWeek.getMonth() + 1) < 10 ? '0' : '') + (dateToWeek.getMonth() + 1) + '-' + (dateToWeek.getDate() < 10 ? '0' : '') + dateToWeek.getDate();
      this.choosenPeriod.push(formattedDateStart, formattedDateEnd );
    }

  },
  mounted(){
    if(this.currentTab == 'ordersEducation'){
      this.choosenRole = 'retoucher';
      this.showUserSelect();
    }
  }
}
</script>
<style>
  @import '../../../assets/css/uikit/list.css';
  .tm-history-grid-head,
  .tm-history-grid {
    line-height: 1.2;
  }
</style>